import type BookingServiceWindow from 'owa-service/lib/contract/BookingServiceWindow';
import type { BookingServiceWindowInput } from 'owa-graph-schema';
import mapWorkHours from './mapWorkHours';
import getFormattedDate from './../utils/getFormattedDate';

const mapBookingServiceWindow = (
    bookingServiceWindows: BookingServiceWindow[] | undefined
): BookingServiceWindowInput[] | undefined => {
    if (!bookingServiceWindows) {
        return;
    }

    const modifiedBookingServiceWindows: BookingServiceWindowInput[] = bookingServiceWindows?.map(
        bookingServiceWindow => ({
            startDate: getFormattedDate(bookingServiceWindow.StartString),
            endDate: getFormattedDate(bookingServiceWindow.EndString),
            bookableHours: mapWorkHours(bookingServiceWindow.BookableHours),
        })
    );
    return modifiedBookingServiceWindows;
};

export default mapBookingServiceWindow;
